import React, { useState, useRef } from 'react';
import {Trans,  useTranslation } from 'react-i18next';
import Webcam from 'react-webcam';
import ReactCrop, {centerCrop, makeAspectCrop}  from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ImagePicker = ({title, onSelected, onCancel, avatar=false}) => {
  const [source, setSource] = useState(null);
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState(); //({unit: "%", width: 100, height:100});

  const webcamRef = useRef(null);
  const imgRef = useRef(null);

  const { t } = useTranslation();

  const imageCaptured = () => {
    setImage(webcamRef.current.getScreenshot());
  };

  const fileSelected = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const imageLoaded = (e) => {
    const { width, height } = e.currentTarget;
    if(avatar) {
        //const crop = makeAspectCrop({unit: "%", width: 80}, 1, width, height);
        const crop = makeAspectCrop({unit: "px", width: Math.min(width, height)}, 1, width, height);
        const centeredCrop = centerCrop(crop, width, height);
        setCrop(centeredCrop);
    } else {
        setCrop({unit: "px", width: width, height:height, x:0, y:0});
    }

  };

  const cropComplete = () => {
    if (crop && crop.width && crop.height) {
        const tmpImage = new Image();
        tmpImage.src = image;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        tmpImage.onload = () => {
            const widthRatio = tmpImage.width/imgRef.current.width
            const heightRatio = tmpImage.height/imgRef.current.height

            canvas.width = crop.width*widthRatio;
            canvas.height = crop.height*heightRatio;

            ctx.drawImage(tmpImage,crop.x*widthRatio,crop.y*heightRatio,canvas.width,canvas.height,0,0,canvas.width,canvas.height);
            const croppedImageUrl = canvas.toDataURL('image/jpeg');
            //   console.log('Cropped Image URL:', croppedImageUrl);
            onSelected(croppedImageUrl)
        };
    }
  };

  const selectSource = (source) => {
    setSource(source);
  };

  return (
    <div className='overlay center-div align-items-center' onClick={()=>onCancel()}>
        {!source && <div className='image-source-select' onClick={(e)=>e.stopPropagation()}>
            <div className='mt20 font-20'>{title}</div>
            <div className='mt10 flex justify-content-space-evenly align-items-center'>
                <div onClick={()=>selectSource('camera')}>
                    <div><img src={'/images/camera.png'} className='image-picker-icon image-picker-camera-icon' alt=''/></div>
                    <div>{t('camera')}</div>
                </div>
                <div onClick={()=>selectSource('gallery')}>
                    <div><img src={'/images/gallery.png'} className='image-picker-icon' alt=''/></div>
                    <div>{t('gallery')}</div>
                </div>
            </div>
        </div>}

        {(source==='camera' && !image) && <div className='center-div align-items-center width-100 background-white flex-direction-column border-radius-20' onClick={(e)=>e.stopPropagation()}>
            <div className='mt20'/>
            <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={'95%'}
            />
            <div className='shadow-button-list mt10' onClick={imageCaptured}>Capture Image</div>
            <div className='shadow-button-list mt10 mb20' onClick={()=>onCancel()}>{t('cancel')}</div>
        </div>}

        {(source==='gallery' && !image) && <div className='center-div align-items-center width-80 background-white flex-direction-column border-radius-20' onClick={(e)=>e.stopPropagation()}>
            <label htmlFor="file-upload" className="mt20 shadow-button-list">
                {t('Choose File')}
            </label>
            <input id='file-upload' className='shadow-button-list' type="file" accept="image/*" onChange={fileSelected} />
            <div className='shadow-button-list mt20 mb20' onClick={()=>onCancel()}>{t('cancel')}</div>
        </div>}

        {image && (
            <div className='center-div align-items-center width-100 background-white flex-direction-column' onClick={(e)=>e.stopPropagation()}>
                <div className='mt20'/>
                <ReactCrop
                    crop={crop}
                    onChange={newCrop => setCrop(newCrop)}
                    // onChange = {(crop, percentCrop) => setCrop(percentCrop)}
                    circularCrop={avatar}
                    keepSelection
                    aspect={avatar?1:null}
                >
                    <img className='cropper-img'
                        ref={imgRef}
                        src={image}
                        alt="Upload"
                        style={{ maxHeight: "85vh" }}
                        onLoad={imageLoaded}
                    />
                </ReactCrop>

                <div className='shadow-button-list mt10' onClick={() => cropComplete()}>
                    {t('Crop Image')}
                </div>
                <div className='shadow-button-list mt10 mb20' onClick={()=>onCancel()}>{t('cancel')}</div>
            </div>
        )}
    </div>
  );
};

export default ImagePicker;
